import Vue from 'vue';
import Rsa from './Rsa';
import globalConfig from './globalConfig';
import formatDate from './formatDate';
import Fingerprint2 from 'fingerprintjs2';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';

const rsa = new Rsa();
const mainHost = globalConfig.getMainHost();
export const EventBus = new Vue();
export let convertParamToString = function (params) {
  let paramArray = [];
  for (let key in params) {
    let val = params[key];
    if (typeof val === 'object') {
      val = JSON.stringify(val);
    }
    let param = key + '=' + val;
    paramArray.push(param);
  }
  paramArray.push('callback');
  if (paramArray.length > 0) {
    return paramArray.join('&');
  }
  return '';
};

export function b64DecodeUnicode(str) {
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );
}

export function b64EncodeUnicode(str) {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_match, p1) {
      return String.fromCharCode('0x' + p1);
    })
  );
}

export const encryption = function (text) {
  return rsa.encode(text);
};

export const SOUTHEST_ASIA_MODE = 1;
export const WESTTERN_MODE = 2;

const MAIN_HOST = globalConfig.getMainHost();
export const EXCHANGE_URL = `//gevents.${mainHost}/globalexchange/indexm.html`;
export const FEEKBACK_URL = `//service.${MAIN_HOST}`;
export const SERVICE_TERM_URL = `//gpassport.${MAIN_HOST}/center/servicePrivicy/service`;
export const PRIVICY_TERM_URL = `//gpassport.${MAIN_HOST}/center/servicePrivicy/privicy`;
export const STORE_PAGE_BASE_URL = `//pay.${MAIN_HOST}`;
export const RES_HOST = `//abres.octlib.com/`;
export const PAYTYPE_ICON_URL = `//cdnimages.awselbcombine.com/public_images/paytype_ext/`;

export const renderGoogleRecaptcha = function (id, key) {
  if (window.grecaptcha.render) {
    window.grecaptcha.render(id, {
      sitekey: key,
      callback: 'onSubmit'
    });
  } else {
    window.recaptchaOnload = () => {
      window.grecaptcha.render(id, {
        sitekey: key,
        callback: 'onSubmit'
      });
    };
  }
};

export const submitGoogleRecaptcha = function (callback) {
  window.onSubmit = token => {
    window.grecaptcha.reset();
    if (callback instanceof Function) {
      callback(token);
    }
  };
};

export let changePriceFormat = function (currency, amount) {
  let price = amount;
  if (currency === 'VND') {
    price = parseInt(amount.replace(/\.\d{2}$/, ''));
    price = price.toLocaleString('vi-VN') + '';
  }
  return price;
};

export const injectScript = function (scriptPath, callback, errCallback) {
  let scriptNode = document.createElement('SCRIPT');
  scriptNode.type = 'text/javascript';
  scriptNode.src = scriptPath;

  scriptNode.onerror = function () {
    errorReport(ERROR_TYPE.INJECT_SCRIPT_FAIL, {
      scriptPath: scriptPath || '',
    });
    if (errCallback && typeof errCallback === 'function') {
      errCallback();
    }
  };

  let headNode = document.getElementsByTagName('head');
  if (headNode[0] != null) headNode[0].appendChild(scriptNode);
  if (callback != null) {
    scriptNode.onreadystagechange = callback;
    scriptNode.onload = callback;
  }
};

export const replaceDateAndPricesOfText = ({ date, prices, text }) => {
  let newDate = formatDate(new Date(date.replace(/-/g, '/')), 'yyyy-MM-dd');
  const [year, month, day] = newDate.split('-');
  let newText = text
    .replace('${year}', year)
    .replace('${month}', month)
    .replace('${day}', day);

  if (prices) {
    newText = newText.replace('${prices}', prices);
  }
  return newText;
};

/**
 * 精确加法
 */
export const plus = (...nums) => {
  if (nums.length > 2) {
    return iteratorOperation(nums, plus);
  }

  const [num1, num2] = nums;
  // 取最大的小数位
  const baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
  // 把小数都转为整数然后再计算
  return (times(num1, baseNum) + times(num2, baseNum)) / baseNum;
};

/**
 * 迭代操作
 */
const iteratorOperation = (arr, operation) => {
  const [num1, num2, ...others] = arr;
  let res = operation(num1, num2);

  others.forEach(num => {
    res = operation(res, num);
  });

  return res;
};

const digitLength = num => {
  const eSplit = num.toString().split(/[eE]/);
  const len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
  return len > 0 ? len : 0;
};

/**
 * 精确乘法
 */
export const times = (...nums) => {
  if (nums.length > 2) {
    return iteratorOperation(nums, times);
  }

  const [num1, num2] = nums;
  const num1Changed = float2Fixed(num1);
  const num2Changed = float2Fixed(num2);
  const baseNum = digitLength(num1) + digitLength(num2);
  const leftValue = num1Changed * num2Changed;

  checkBoundary(leftValue);

  return leftValue / Math.pow(10, baseNum);
};

/**
 * 精确减法
 */
export const minus = (...nums) => {
  if (nums.length > 2) {
    return iteratorOperation(nums, minus);
  }

  const [num1, num2] = nums;
  const baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
  return (times(num1, baseNum) - times(num2, baseNum)) / baseNum;
};

/**
 * 把小数转成整数，支持科学计数法。如果是小数则放大成整数
 * @param {*number} num 输入数
 */
const float2Fixed = num => {
  if (num.toString().indexOf('e') === -1) {
    return Number(num.toString().replace('.', ''));
  }
  const dLen = digitLength(num);
  return dLen > 0 ? strip(Number(num) * Math.pow(10, dLen)) : Number(num);
};

let _boundaryCheckingState = true;

/**
 * 检测数字是否越界，如果越界给出提示
 * @param {*number} num 输入数
 */
const checkBoundary = num => {
  if (_boundaryCheckingState) {
    if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
      console.warn(
        `${num} is beyond boundary when transfer to integer, the results may not be accurate`
      );
    }
  }
};

export const initViewport = () => {
  let metaEl = document.querySelector('#viewportMeta');
  let content = metaEl.getAttribute('content');
  if (content.indexOf('height') > -1) {
    return;
  }
  content = content + ',height=' + window.innerHeight;
  metaEl.setAttribute('name', 'viewport');
  metaEl.setAttribute('content', content);
};

export const getFingerprint = UUID => {
  return new Promise(resolve => {
    /**
     * 采用localstorage和cookie双储存
     */
    let locaUUid = globalConfig.getLclStorageItem(UUID);
    let cookUUid = globalConfig.getCookie(UUID);
    let saveUuid = locaUUid || cookUUid;
    if (saveUuid) {
      if (!cookUUid || (locaUUid && locaUUid !== cookUUid)) {
        globalConfig.setCookie(UUID, saveUuid);
      }
      if (!locaUUid) {
        globalConfig.setLclStorageItem(UUID, saveUuid);
      }
      resolve(saveUuid);
    } else {
      Fingerprint2.getV18(
        {
          excludes: {
            language: true
          }
        },
        function (result, _components) {
          let timestamp = new Date().valueOf();
          let realUuid = result + timestamp;
          globalConfig.setLclStorageItem(UUID, realUuid);
          globalConfig.setCookie(UUID, realUuid);
          resolve(realUuid);
        }
      );
    }
  });
};

/**
 * 判断是否是数组
 * @param {*} arr
 * @returns boolean
 */
export const isArray = arr => {
  if (!arr) {
    return false;
  }
  return /Array/i.test(arr.constructor.toString());
};

/**
 * 在对象数组中，根据对象某个key的value，找出最小的一项
 * @param {*} arr 数组
 * @param {*} targetKey 用于判断大小对象的key
 * @returns Object || null
 */
export const getMinItemFromArr = (arr, targetKey) => {
  let minItem = null;
  if (!isArray(arr)) {
    return minItem;
  }
  for (let i = 0, length = arr.length; i < length; i++) {
    if (arr[i] && arr[i][targetKey]) {
      const itemTargetValue = arr[i][targetKey];
      const itemTargetValueNumber = Number(itemTargetValue);
      if (isNaN(itemTargetValueNumber)) {
        continue;
      }
      if (minItem === null) {
        minItem = arr[i];
        continue;
      }
      if (Number(minItem[targetKey]) > itemTargetValueNumber) {
        minItem = arr[i];
      }
    }
  }
  return minItem;
};

// timestamp : 时间戳，单位为秒
export const couponLocalDateFormat = (timestamp, lang) => {
  return new Date(+timestamp * 1000).toLocaleString(lang, {
    hour12: false,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  });
};

// timestamp : 时间戳，单位为秒
export const countDownTimeFormat = timestamp => {
  // 格式化时间
  let days = Math.floor(timestamp / 86400);
  let hours = Math.floor((timestamp % 86400) / 3600);
  let minutes = Math.floor(((timestamp % 86400) % 3600) / 60);
  let seconds = Math.floor(timestamp % 60);

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;
  return {
    days,
    hours,
    minutes,
    seconds
  };
};

// 获取当前时间戳对应的日期
export const timestampToDateFormat = timestamp => {
  // 创建一个 Date 对象，使用给定的 UTC 时间戳
  const date = new Date(timestamp);

  // 格式化日期为 YYYY/MM/DD HH:MM:SS
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要+1，并且补位
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};
